export interface DashletWithAiBlock {
  config?: {
    feExtraInfo?: {
      aiBlock?: { conversationId: string } | null;
      [key: string]: unknown;
    } | null;
    [key: string]: unknown;
  } | null;
  [key: string]: unknown;
}

export const getDashletConversationId = (
  dashlet: DashletWithAiBlock | null | undefined
): string | null =>
  dashlet?.config?.feExtraInfo?.aiBlock?.conversationId ?? null;

export const isAiBlockDashlet = (
  dashlet: DashletWithAiBlock | null | undefined
): boolean => getDashletConversationId(dashlet) !== null;
